// import './style.scss';
import { initConfetti } from './initConfetti';

const claim = () => {
  if ($('.js-claim-team-players').length === 0) {
    return;
  }

  initConfetti();

  var currentIndex = 0;

  function setPlayer(index){
      const player = window.playerData[index];
      const playerAttributes = $.parseJSON(player.player_attributes);
      console.log(player)
      var nationality = playerAttributes.nationality;

      var nat = "/html/cornerkick/assets/images/flags/Flag_of_" + nationality?.replace(" ","_") + ".png"
      console.log(nat)
      $('.playermodal .card-rating').text(player.overall);
      $('.playermodal .card-position').text('');
      $('.playermodal .card-position').each(function(i,item){
          $(item).text(player.positions[i]??'');
      });

      $('.playermodal #player_name').text(player.name);
      $('.playermodal #player_technique').text(player.technique);
      $('.playermodal #player_power').text(player.power);
      $('.playermodal #player_stamina').text(player.stamina);
      $('.playermodal #player_mental').text(player.mental);
      $('.playermodal #player_form').text(player.form);
      $('.playermodal .card-image').attr('src', player.image);
      $('.playermodal .card-national').attr('src', nat);
      $('.playermodal .card-aside').attr('href', player.seo);
      $('.playermodal .card-main').attr('href', player.seo);
      $('.playermodal .card-info span').text(player.rarity);
  }

  $(function() {
      $('.js-next-player').on('click', function(e){

        // playermodal fadeOut jquery
        $('.playermodal').fadeOut(500, function() {
          $('.js-players').eq(currentIndex).removeClass('d-none');
          if (currentIndex < (window.playerData.length - 1)){
            currentIndex++;
            $(e.target).animate({opacity: 1});
          } else {
            $(e.target).animate({opacity: .4});
            $('.js-claim-team-players').find('.card').remove();
            $(e.currentTarget).remove();
            $('.js-go-to-team').removeClass('d-none');
          }
          setPlayer(currentIndex);
        });

        // playermodal fadeIn jquery
        $('.playermodal').fadeIn(500, function() {
        });
      });

      setPlayer(0);
  });
};


export default claim;
